import { useQuery } from '@tanstack/react-query';
import type {
  CareStatePriorAuthStatusT,
  PriorAuthSummaryT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchPatientPriorAuths } from '../api/priorAuthApi';
import { priorAuthKeys } from './keys';

const REFRESH_INTERVAL_MS = 30_000;
const INSURANCE_OWNED_STATUSES = new Set<CareStatePriorAuthStatusT>([
  'Requested',
  'Appealing',
  'Cancel Requested',
]);

export function patientPriorAuthsQueryDefinition(patientUserId: string) {
  return {
    queryKey: priorAuthKeys.patientList(patientUserId),
    queryFn: ({ signal }: { signal?: AbortSignal }) =>
      fetchPatientPriorAuths(patientUserId, signal),
    meta: {
      toast: {
        title: 'Could not load prior authorizations',
        description: 'Prior authorization cases could not be fetched.',
      },
    },
    refetchInterval: (query: { state: { data?: PriorAuthSummaryT[] } }) => {
      const cases = query.state.data;
      return cases?.some(({ status }) => status == null || INSURANCE_OWNED_STATUSES.has(status))
        ? REFRESH_INTERVAL_MS
        : false;
    },
    refetchIntervalInBackground: false,
  } as const;
}

export function usePatientPriorAuthsQuery(patientUserId: string | undefined) {
  return useQuery({
    ...patientPriorAuthsQueryDefinition(patientUserId ?? ''),
    enabled: !!patientUserId,
  });
}
